import React from 'react';
import PROFILES from '../data/profiles';

const Profile = props => {
    const {  name, description, picture, title } = props.profiles;
    return (
        <div className="profileHeader" id="profileHeader">
            <h2 className="profile">{name}</h2>
            <h3>{title}</h3>
            <hr></hr>
            <img src={picture} alt='Profile Picture' className='profilePicture'></img>
            <br />
            
            <p className="profileDescription">
            <br />
                {description}
            </p>
        </div>
    )

}

const Profiles = () => (
    <div className="profileTotal">
        <h1 id="profileAbout">About Us</h1>
        <div className="profileSectionTotal">

            {
                PROFILES.map(PROFILE => {
                    return (
                        <Profile key={PROFILE.id} profiles={PROFILE} />
                    );
                })
            }
        </div>
    </div>
)

export default Profiles;